import React from "react";
import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Box,
    Avatar,
    Stack,
} from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import { cardSx, sectionSubtitleSx, sectionTitleSx } from "./homeStyles";

function HomeMetrics() {
    const metricCards = [
        {
            value: "Сверка с бухучетом",
            label: "Сверка банковских платежных поручений с данными бухгалтерского учета для выявления фактов хищений и переплат",
            icon: <AccountBalanceWalletOutlinedIcon />,
        },
        {
            value: "Сверка с кадрами",
            label: "Сверка банковских платежных поручений с данными кадров (HR) для выявления лиц, не состоящих в трудовых отношениях",
            icon: <BadgeOutlinedIcon />,
        },
        {
            value: "Конвертация",
            label: "Для самостоятельной проверки проведенных платежей в банке с платежной ведомостью (расчетно-платежной ведомостью)",
            icon: <SwapHorizOutlinedIcon />,
        },
    ];

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
            <Box textAlign="center" sx={{ mb: { xs: 4, md: 5 } }}>
                <Typography variant="h3" sx={sectionTitleSx}>
                    Основной функционал
                </Typography>

                <Typography sx={sectionSubtitleSx}>
                    Автоматизированная сверка банковских платежей с данными
                    бухгалтерского и кадрового учета
                </Typography>
            </Box>

            <Grid container spacing={2.5} justifyContent="center">
                {metricCards.map((item) => (
                    <Grid
                        size={{ xs: 12, sm: 6, md: 4 }}
                        key={item.label}
                        sx={{ display: "flex" }}
                    >
                        <Card sx={{ ...cardSx, width: "100%" }}>
                            <CardContent
                                sx={{
                                    p: { xs: 2.5, md: 3 },
                                    textAlign: "center",
                                }}
                            >
                                <Stack
                                    spacing={2}
                                    alignItems="center"
                                    sx={{ height: "100%" }}
                                >
                                    <Avatar
                                        sx={{
                                            width: 56,
                                            height: 56,
                                            bgcolor: "rgba(37, 99, 235, 0.10)",
                                            color: "#2563eb",
                                        }}
                                    >
                                        {item.icon}
                                    </Avatar>

                                    <Typography
                                        sx={{
                                            fontSize: { xs: 22, md: 25 },
                                            fontWeight: 800,
                                            color: "#0f172a",
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {item.value}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#475569",
                                            lineHeight: 1.72,
                                            fontSize: { xs: "0.96rem", md: "1rem" },
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default HomeMetrics;